

export const config = {
    // apiEndpoint: "https://preprodshikharapp.hulsecure.in/public/index.php/api",
    // apiUrl: "https://preprod.xpressbaazaar.com/invl",
    // baseNodeapiUrl: "https://preprod.xpressbaazaar.com/invl",
    // apibaseUrl: "https://preprod.xpressbaazaar.com/v1",
    // uploadUrl: "https://preprod.xpressbaazaar.com/invl",

    //prod url
    apiEndpoint: "https://invl.xpressbaazaar.com/public/index.php/api",
    apiUrl: "https://ondc.xpressbaazaar.com/invl",
    baseNodeapiUrl: "https://ondc.xpressbaazaar.com/invl",
    apibaseUrl: "https://ondc.xpressbaazaar.com/v1",
    uploadUrl: "https://ondc.xpressbaazaar.com/invl",

    awsKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
    awsSecretKey: process.env.REACT_APP_SECRET_ACCESS_KEY,
    awsRegion: process.env.REACT_APP_AWS_REGION,
    awsBucket: process.env.REACT_APP_AWS_BUCKET,
}


